import React, { Fragment, useState } from "react";
import { Col, Container, Row, Button, Table } from "reactstrap";
import useAxios from "../../../Utils/useAxios";
import { useNavigate } from "react-router-dom";

import { timeToast } from "../../../Constant";
import { toast } from "react-toastify";
import { FORM_TYPE } from "../../../Constant/FormType";
import { formatRP } from "../../../Utils/externalFunctions";
import {
  APISentFailedMsg,
  APISentSuccessMsg,
  getItemCreateSuccessMsg,
  getItemEditSuccessMsg,
} from "../../../Constant/Message";
import DATA_TYPE from "../../../Constant/DataType";
import { useThemeContext } from "../../../Context/ThemeContext";
import { getDarkTableRow } from "../../../Utils/otherFunctions";
import {
  createAnggaranDipakaiTransaksi,
  createTransaksi,
  updateTransaksi,
} from "../services";
toast.configure();

const StepTiga = ({
  prevStep,
  total,
  formTransaksi,
  rencImp,
  anggaranRencimpTransaksi,
  formType,
}) => {
  console.log(formTransaksi);
  console.log(anggaranRencimpTransaksi);
  const axiosInstance = useAxios();
  const navigate = useNavigate();
  const [waitingForSubmit, setWaitingForSubmit] = useState(false);

  const { themeContext } = useThemeContext();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setWaitingForSubmit(true);

      if (formType === FORM_TYPE.Create) {
        createTransaksi(axiosInstance, formTransaksi).then(() => {
          createAnggaranDipakaiTransaksi(
            axiosInstance,
            anggaranRencimpTransaksi
          ).then(() => {
            console.log(APISentSuccessMsg);
            toast.success(getItemCreateSuccessMsg(DATA_TYPE.Transaksi), {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: timeToast,
            });
            navigate(`${process.env.PUBLIC_URL}/transaksi/`);
          }).finally(() => {
            setWaitingForSubmit(false);
          })
        });
      } else {
        updateTransaksi(axiosInstance, formTransaksi.id, formTransaksi).then(
          () => {
            createAnggaranDipakaiTransaksi(
              axiosInstance,
              anggaranRencimpTransaksi
            ).then(() => {
              console.log(APISentSuccessMsg);
              toast.success(getItemEditSuccessMsg(DATA_TYPE.Transaksi), {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: timeToast,
              });
              navigate(`${process.env.PUBLIC_URL}/transaksi/`);
            });
          }
        ).finally(() => {
          setWaitingForSubmit(false);
        })
      }
    } catch (error) {
      console.log(APISentFailedMsg);
      toast.error(`POST Transaksi ${error.message}`, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: timeToast,
      });
    }
  };

  const findRencImp = (id) => {
    const itemWithId = rencImp.find((item) => item.pk === id);
    return itemWithId ? itemWithId : "Unknown";
  };

  return (
    <Fragment>
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Table responsive>
              <thead>
                <tr>
                  <th className={getDarkTableRow(themeContext)}>DPSJ</th>
                  <th className={getDarkTableRow(themeContext)}>Kegiatan</th>
                  <th className={getDarkTableRow(themeContext)}>Akun</th>
                  <th className={getDarkTableRow(themeContext)}>Jumlah (Rp)</th>
                </tr>
              </thead>
              <tbody>
                {anggaranRencimpTransaksi.map((art) => (
                  <tr key={art.rencana_imp}>
                    <td scope="row" className={getDarkTableRow(themeContext)}>
                      {findRencImp(parseInt(art.rencana_imp)).nm_org}
                    </td>

                    <td className={getDarkTableRow(themeContext)}>
                      {findRencImp(parseInt(art.rencana_imp)).kd_keg}-
                      {findRencImp(parseInt(art.rencana_imp)).nm_keg}
                    </td>
                    <td className={getDarkTableRow(themeContext)}>
                      {findRencImp(parseInt(art.rencana_imp)).kd_akun}-
                      {findRencImp(parseInt(art.rencana_imp)).nm_akun}
                    </td>
                    <td className={getDarkTableRow(themeContext)}>
                      {formatRP(art.anggaran_digunakan)}
                    </td>
                  </tr>
                ))}
                <tr>
                  <th
                    scope="row"
                    className={getDarkTableRow(themeContext)}
                  ></th>
                  <td className={getDarkTableRow(themeContext)}></td>
                  <td className={getDarkTableRow(themeContext)}>
                    <strong>Total</strong>
                  </td>
                  <td className={getDarkTableRow(themeContext)}>
                    {formatRP(total)}
                  </td>
                </tr>
              </tbody>
            </Table>

            <div className="row justify-content-between m-4">
              <div className="col-auto">
                <Button onClick={prevStep}>Kembali</Button>
              </div>
              <div className="col-auto">
                <Button
                  color="primary"
                  variant="contained"
                  onClick={handleSubmit}
                  disabled={waitingForSubmit}
                >
                  Submit
                </Button>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};
export default StepTiga;
